import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Tooltip, Button } from '@mui/material'
import Icon from '@mui/material/Icon'
import AddIcon from '@mui/icons-material/Add'
import { DataGrid } from '@mui/x-data-grid'
import { RootState } from '../../reducers'
import { getITAdminSettingsData } from '../../actions'
import { useStyles } from './SettingsStyles'
import EditProcedureCodeDialog from './EditProcedureCodeDialog'
import AddProcedureCodeDialog from './AddProcedureCodeDialog'
import DeleteDialog from '../HOC/DeleteDialog'
import SuccessSnackBar from '../HOC/SuccesSnackBar'
import ErrorSnackBar from '../HOC/ErrorSnackBar'
import { DeleteITAdminSettings } from '../../actions/api/fetchITAdmin'

function ITAdminSettingsTable({ userId, tableColumns }) {
  const classes = useStyles()
  const { role, userLogin } = useSelector((state: RootState) => state.userLogin)
  const [addOpen, setAddOpen] = useState(false)
  const [editOpen, setEditOpen] = useState(false)
  const [paramsInfo, setParamsInfo] = useState({ id: 0 })
  const [infoPassed, setInfoPassed] = useState(false)
  const [deleteProcedureCodeOpen, setDeleteProcedureCodeOpen] = useState(false)
  const [addProcedureCode, setAddProcedureCode] = useState(false)
  const [editProcedureCode, setEditProcedureCode] = useState(false)
  const dispatch = useDispatch()
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const { re_procedure_code_success, re_procedure_code_error } = useSelector(
    (state: RootState) => state.deleteSettingResponse,
  )
  const { delete_holiday_success, delete_holiday_error } = useSelector(
    (state: RootState) => state.deleteHolidayResponse,
  )

  const SettingsData = useSelector((state: RootState) => state.getITAdminSettingsData)

  useEffect(() => {
    dispatch(getITAdminSettingsData({ id: `${userLogin}` }))
  }, [])

  const displayAssignedData = SettingsData.payload

  const AssignedIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    width: 300,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    renderCell: (params) => {
      return (
        <div>
          <Tooltip title="Edit Procedure Code" placement="left-end">
            <Icon onClick={() => handleEditProcedureCodeOpen(params.row)}>edit_outlined</Icon>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Delete Procedure Code" placement="left-end">
            <Icon onClick={() => handleDeleteProcedureCodeOpen(params.row)}>delete_outlined</Icon>
          </Tooltip>
        </div>
      )
    },
  }

  tableColumns.push(AssignedIconRender)

  const handleAddProcedureCodeOpen = () => {
    setAddProcedureCode(true)
    setAddOpen(true)
    setInfoPassed(true)
  }
  const handleEditProcedureCodeOpen = (params) => {
    setParamsInfo(params)
    setEditOpen(true)
    setEditProcedureCode(true)
    setInfoPassed(true)
  }

  const handleDeleteProcedureCodeClose = () => setDeleteProcedureCodeOpen(false)

  const handleDeleteProcedureCodeOpen = (params) => {
    setDeleteProcedureCodeOpen(true)
    setParamsInfo(params)
  }

  const handleAddClose = () => setAddOpen(false)
  const handleEditClose = () => setEditOpen(false)

  const handleSubmit = async (event) => {
    setOpenSuccessSnackBar(false)
    await dispatch(DeleteITAdminSettings({ payload: { id: paramsInfo?.id } }))
    handleDeleteProcedureCodeClose()
    setOpenSuccessSnackBar(true)
    await dispatch(getITAdminSettingsData({ id: `${userLogin}` }))
  }

  return (
    <div className={classes.container}>
      {infoPassed && addProcedureCode && <AddProcedureCodeDialog open={addOpen} handleClose={handleAddClose} />}
      {infoPassed && editProcedureCode && (
        <EditProcedureCodeDialog open={editOpen} handleClose={handleEditClose} params={paramsInfo} />
      )}

      {re_procedure_code_success && openSuccessSnackBar && (
        <SuccessSnackBar message="Successfully deleted the procedure code" />
      )}
      {re_procedure_code_error && openSuccessSnackBar && (
        <ErrorSnackBar message="Procedure code can not be deleted as it is associated with a case or pathologist profile" />
      )}

      <div className={classes.mt}>
        <Box
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#0d688d73',
              fontWeight: '600',
            },
            '& .MuiDataGrid-columnHeader--moving': {
              backgroundColor: 'transparent !important',
            },
          }}
        >
          <Button
            className={classes.addProcedureCodeBtn}
            onClick={() => handleAddProcedureCodeOpen()}
            startIcon={<AddIcon />}
          >
            Add Procedure Code
          </Button>

          <DataGrid
            disableColumnSelector
            autoHeight
            pagination
            pageSize={10}
            rowsPerPageOptions={[10]}
            rows={displayAssignedData}
            columns={tableColumns}
            loading={displayAssignedData?.fetchInProgress}
          />
          {deleteProcedureCodeOpen && (
            <DeleteDialog
              open={deleteProcedureCodeOpen}
              onClose={handleDeleteProcedureCodeClose}
              handleSubmit={handleSubmit}
              header={'Delete Procedure Code'}
            />
          )}
        </Box>
      </div>
    </div>
  )
}

export default ITAdminSettingsTable
